import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.snowflakeDataPushStatus;

const snowflakeDataPushStatusData = createSelector([selector], (state) => state);

export default {
  snowflakeDataPushStatusData
};